import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import {
    action_fetch_home_clogs,
    action_fetch_home_titles,
    action_add_home_clogs,
    action_fetch_home_banner
} from '../../../../store/actions/pages/c-log'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

import List from '../components/list'
import { useQuery } from '../../../hooks/common'
import TitleTags from './components/title-tags'
import { useHistory, useLocation } from 'react-router-dom'
import CLogBanner from './components/clg-banner';

import { useRouteMatch } from 'react-router-dom'
import { matchRoutes } from 'react-router-config'
import routes from '../../../../routes/c-log'
import BottomNavigation from '../../../layout/fragments/bottom-navigation'

const CLog = props => {
    useStyles(classes)
    const pageCLog = useSelector(state => state.pageCLog)
    const dispatch = useDispatch()
    const store = useStore()
    const history = useHistory()
    const location = useLocation()
    const query = useQuery()

    const match = useRouteMatch()

    useEffect(() =>{
        const branches = matchRoutes(routes, match.url)
        const routeExample = branches?.[0]?.route;

        window.pageTitle = routeExample?.cn_page
        if (window.GeekoSensors) {
            window.GeekoSensors.Quick('autoTrackSinglePage', {page_title: routeExample?.cn_page})
        }
    },[]);

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
            delete window.__INITIAL_STATE__
        } else {
            CLog.fetchData(store, {tag: query?.tag}, query, {})
            window.scrollTo({
                top: 0,
            })
        }
    }, [query?.tag])

    const onRequest = () => {
        const value = query?.tag || pageCLog?.homeTitles?.[0]?.value
        dispatch(action_add_home_clogs({ tag:value, skip: pageCLog?.homeSkip }, {}))
    }

    const tagHandle = useCallback(async tag => {
        history.replace(`${location.pathname}?tag=${tag?.value}`)
    }, [])

    return <div> 
        {
            pageCLog?.homeBanner && <CLogBanner bannerData={pageCLog?.homeBanner} />
        }

        <div>
            <TitleTags onTag={tagHandle} selectedTag={pageCLog?.homeTitles?.find?.(t => t.value === query?.tag)?.value || pageCLog?.homeTitles?.[0]?.value} tags={pageCLog.homeTitles} />
        </div>
        <div className={classes.List}>
            <List showings={pageCLog.homeClogs} request={onRequest} loading={pageCLog.homeLoading} finished={pageCLog.homeFinished} tab={query?.tag || pageCLog?.homeTitles?.[0]?.value} />
        </div>

        <BottomNavigation />
    </div>
}

CLog.fetchData = async (store, params, search, headers) => {
    const titles = await store.dispatch(action_fetch_home_titles(headers))
    const tag = search?.tag || titles?.[0]?.value
    const list = await store.dispatch(action_fetch_home_clogs({ tag }, headers))
    const banner = await store.dispatch(action_fetch_home_banner(headers));
}

export default CLog
